export const INVITE_LEASE_DETAILS_VALIDATION_MESSAGES = {
  APPLICANT_EMAIL_REQUIRED: 'Applicant email is required',
  APPLICANT_EMAIL_MAX_COUNT: 'Maximum number of roommates is 6',
  APPLICANT_EMAIL_INVALID: 'Invalid email',
  EMAIL_REQUIRED: 'Email is required',
  APPLICANT_EMAIL_UNIQUE: 'Applicant emails need to be unique',
  APPLICANT_EMAIL_UNIQUE_IGNORING_CASE: 'Applicant emails need to be unique (ignoring case)',
  ADDRESS_REQUIRED_MESSAGE: 'Address is required',
  ADDRESS_NOT_FOUND: 'Address was not found',
  MONEY_FIELD_TYPE_ERROR: 'Value should be a number',
  MONEY_FIELD_MIN: 'Minimum amount can be as low as $0',
  MONEY_FIELD_MAX: 'Maximum amount can be up to $50,000',
  APARTMENT_NUMBER_TOO_LONG: 'Apartment number is too long',
  UNIT_NUMBER_REQUIRED: 'Unit number is required',
  LEASE_START_REQUIRED: 'Lease start date is required',
  LEASE_START_INVALID: 'Lease start date is invalid',
  DATE_ONE_YEAR_PAST: 'Date can be up to 1 year in the past',
  DATE_ONE_YEAR_FUTURE: 'Date can be up to 1 year in the future',
  LEASE_END_REQUIRED: 'Lease end date is required',
  LEASE_END_INVALID: 'Lease end date is invalid',
  LEASE_END_AFTER_START: 'End date can only be after start date',
  LEASE_DURATION_MIN_THREE_MONTHS: 'Lease duration must be at least 3 months',
  LEASE_DURATION_MAX_THIRTY_SIX_MONTHS: 'Lease duration cannot exceed 36 months',
  TOTAL_MONTHLY_RENT_REQUIRED: 'Total monthly rent is required',
  GROSS_MONTHLY_RENT_REQUIRED: 'Gross monthly rent is required',
  INVALID_SCREENING_RESULT: 'Invalid screening result. Please choose a valid option.',
  SCREENING_RESULT_REQUIRED: 'Screening result is required',
  MONTHS_OF_COVERAGE_REQUIRED: 'Months of coverage is required',
  MONTHS_OF_COVERAGE_MIN: 'Months of coverage must be 0 or greater',
  MONTHS_OF_COVERAGE_MAX: 'Months of coverage can be up to 100',
  SECURITY_DEPOSIT_REPLACEMENT_REQUIRED: 'Security deposit replacement amount is required',
  RENT_COVERAGE_REQUIRED: 'Rent coverage is required',
  SECURITY_DEPOSIT_COVERAGE_REQUIRED: 'Security deposit coverage is required',
  amountCannotExceedRentMonths: (months: number) => `Amount cannot exceed ${months} month’s rent`,
} as const;
